import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export function AvailabilityAlert({ date, sede, contractId = "", quoteId = "" }) {
  const [res, setRes] = useState(null);
  useEffect(() => {
    if (!date) {
      setRes(null);
      return;
    }
    api.get("/availability", { params: { date, sede: sede || "", contract_id: contractId, quote_id: quoteId } }).then((r) => setRes(r.data.conflicts)).catch(() => setRes(null));
  }, [date, sede, contractId, quoteId]);
  if (!res) return null;
  if (!res.length) return <div className="text-xs rounded-lg bg-[#F0FDF4] text-[#166534] p-3 inline-flex items-center gap-2" data-testid="availability-free"><CheckCircle2 size={14} /> Data libera{sede ? ` per ${sede}` : ""}</div>;
  return (
    <div className="text-xs rounded-lg bg-[#FEF2F2] text-[#991B1B] p-3 space-y-1" data-testid="availability-conflicts">
      <div className="font-medium inline-flex items-center gap-2"><AlertTriangle size={14} /> Attenzione: questa data è già impegnata</div>
      {res.map((c) => <div key={c.label}>• {c.link ? <Link className="underline" to={c.link}>{c.label}</Link> : c.label} ({c.status})</div>)}
    </div>
  );
}
